<template>
  <section class="page--section">
    <div class="section__title">
      <el-row :gutter="10" type="flex" align="middle">
        <el-col :span="18">
          <h2>{{ $t('trainingInProgressTraining') }}</h2>
        </el-col>
      </el-row>
    </div>
    <el-carousel :height="carouselHeight" v-bind:class="{ 'is-single-page' : numberOfPages == 1 }"
      :autoplay="false"
      trigger="click"
      indicator-position="outside"
      arrow="always">
      <el-carousel-item v-for="page in numberOfPages" :key="page" >
        <el-row :gutter="30">
          <el-col
            :lg="6"
            :md="8"
            :sm="12"
            v-for="userCourse in coursesForPage(page)"
            :key="userCourse.id">

            <training-in-progress-card
              :userCourse="userCourse"
              :courseInfo="courseCatalog.find(course => course.id === userCourse.id)">
            </training-in-progress-card>

          </el-col>
        </el-row>
      </el-carousel-item>
    </el-carousel>
  </section>
</template>

<script>
  import training from '@/components/training';
  import TrainingInProgressCard from '@/components/training/TrainingInProgressCard.vue';
  import { mapActions, mapGetters, mapState } from 'vuex';

  export default {
    name  : 'TrainingInProgress',
    props : {
      usersCourses  : Array,
      courseCatalog : Array,
    },
    computed : {
      ...mapState(training.store.namespace, [
        'getCourseById',
      ]),
      numberOfPages : function() {
        return Math.ceil(this.usersCourses.length / this.coursesPerPage);
      },
      ...mapState(training.store.namespace, [
        'getCourseById',
      ]),
      coursesPerPage : function() {
        // Determine the number of carousel courses per page based on the screen width.
        if (screen.width <= 990){
          return 2;
        }

        if (screen.width < 1200) {
          return 3;
        }

        return 4;
      },
      carouselHeight : function() {
        // Determine the height based on the screen width.
        if (screen.width <= 766){
          return '1100px';
        }

        if (screen.width <= 990){
          return '530px';
        }

        if (screen.width < 1200) {
          return '530px';
        }

        return '480px';
      },
    },
    methods : {
      coursesForPage : function(page) {
        // Return the courses for a specific page of the carousel.
        // Page is passed in starting at 1.
        let start = (page - 1) * this.coursesPerPage;
        let end   = end = start + this.coursesPerPage;
        return this.usersCourses.slice(start, end);
      }
    },
    components : {
      TrainingInProgressCard,
    },
  };
</script>

<style lang="scss">
  .el-carousel.is-single-page{
    .el-carousel__arrow,
    .el-carousel__indicators{
      display:none;
    }
  }
  .el-carousel__button{
    width: 12px;
    height: 12px;
    border-radius: 100%;
  }
  .el-carousel__arrow{
    top: 102%;
    background-color: #ebebeb;

    .el-icon-arrow-left,
    .el-icon-arrow-right{
      color: #1e1e1e;
    }

    &--left{
      left: 20%;
    }
    &--right{
      right: 20%;
    }
  }
  .el-carousel__indicator{

    .el-carousel__button{
      background-color: #DDDDDD;
      opacity: .8;
    }
    &.is-active{
      .el-carousel__button{
        background-color: #D31F25;
      }
    }
  }

</style>